module.exports = __webpack_public_path__ + "img/Steve.8ab50c91.jpeg";